<template>
  <div
    v-if="stepData"
    className="step"
  >
    <template v-for="question in questions">
      <validation-observer
        v-slot="questionObserver"
        :key="`${stepId}_${question.questionId}`"
        slim
      >
        <validation-observer-event-emitter
          :id="`question-${stepId}-${question.questionId}`"
          :observer="questionObserver"
          @update="onQuestionObserverUpdate($event, question.questionId)"
        >
          <component
            :is="question.questionComponent"
            :ref="question.questionId || question.questionComponent"
            :key="question.questionId || question.questionComponent"
            :product-name="productName"
            :product-title="productTitle"
            :step-id="stepId"
            step-type="multiple"
            :question-id="question.questionId"
            v-bind="question.params || {}"
            :form-observer="formObserver"
            :form-data="form"
            :step-data="stepData"
            :is-continue-triggered="isContinueTriggered"
            :is-pet-minimise-helptext-experiment="isPetMinimiseHelptextExperiment"
            @edit-process="$emit('edit-process', $event)"
            @multiform-questions-details="$emit('multiform-questions-details', $event)"
            @multiform-changed="$emit('multiform-changed', $event)"
            @loading="$emit('loading', $event)"
            @continue-available="$emit('continue-available', $event)"
            @show-form-actions="$emit('show-form-actions', $event)"
            @input="stepData = { ...stepData, ...$event }"
          />
        </validation-observer-event-emitter>
      </validation-observer>
    </template>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'form-pet-step-1',
  props: {
    formObserver: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productTitle: {
      type: String,
      required: true,
    },
    stepId: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    isContinueTriggered: {
      type: Boolean,
      required: true,
    },
    isPetMinimiseHelptextExperiment: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      stepData: null,
    };
  },
  watch: {
    stepData: {
      handler (val) {
        this.$emit('step-data', val);
      },
      immediate: true,
    },
    'formObserver.valid': {
      immediate: true,
      handler (val) {
        if (val) this.$emit('valid');
      },
    },
  },
  async created () {
    this.$emit('tracking', this.stepId);
    this.stepData = cloneDeep(this.form[this.stepId]);
    this.formObserver.reset();
  },
  methods: {
    onQuestionObserverUpdate (observer, questionId) {
      this.$emit('question-observer', {
        questionId,
        observer,
      });
    },
  },
};
</script>
